import IMerchantState from "@/types/merchant";
import { GeolocationActions } from "@/apps/merchant3/types/CartGeolocation";
import MerchantFlags from "@/apps/merchant3/types/MerchantFlags";

const getters = {
  merchantState: (state: IMerchantState): IMerchantState => state,

  merchantJwt: (state: IMerchantState): string => {
    if (state.jwt) {
      return `${state.jwt}`;
    }
    return "";
  },

  merchantFlags: (state: IMerchantState): Array<string> => {
    if (state.merchantFlags) {
      return state.merchantFlags;
    }
    return [];
  },

  hasMerchantFlag:
    (state: IMerchantState) =>
    (merchantFlag: string): boolean => {
      return state.merchantFlags.includes(merchantFlag);
    },

  usesGeolocation: (state: IMerchantState): boolean => {
    return (
      state.merchantFlags.includes(MerchantFlags.USE_GEOFENCE) ||
      state.merchantFlags.includes(MerchantFlags.USE_GEO_BLOCK) ||
      state.merchantFlags.includes(
        MerchantFlags.USE_GEO_BLOCK_SALES_OUTSIDE_STORE
      )
    );
  },

  usesPersonManagementSystem: (state: IMerchantState): boolean => {
    return state.merchantFlags.includes(
      MerchantFlags.USE_PERSON_MANAGEMENT_SYSTEM
    );
  },

  usesQuickApprovalFlow: (state: IMerchantState): boolean => {
    return state.merchantFlags.includes(MerchantFlags.USE_QUICK_APPROVAL_FLOW);
  },

  usesRentalFlow: (state: IMerchantState): boolean => {
    return state.merchantFlags.includes(MerchantFlags.USE_RENTAL_MODEL);
  },

  usesSubscriptionFlow: (state: IMerchantState): boolean => {
    return state.merchantFlags.includes(MerchantFlags.USE_SUBSCRIPTION_MODEL);
  },

  geolocationPermissionMissing: (
    state: IMerchantState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    getters: any
  ): boolean => {
    if (!getters.usesGeolocation) return false;
    if (
      !getters.hasMerchantFlag(MerchantFlags.USE_GEO_BLOCK) &&
      !getters.hasMerchantFlag(MerchantFlags.USE_GEO_BLOCK_SALES_OUTSIDE_STORE)
    ) {
      return false;
    }
    if (!state.geolocationCheckDone) return false;
    if (state.geolocationAllowed) return false;

    return true;
  },

  shouldShowGeolocationCheckInProgress: (
    state: IMerchantState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    getters: any
  ): boolean => {
    return (
      getters.hasMerchantFlag(
        MerchantFlags.USE_GEO_BLOCK_SALES_OUTSIDE_STORE
      ) && state.geolocationCheckInProgress
    );
  },

  shouldBlockSalesOutsideStore: (state: IMerchantState): boolean => {
    return (
      state.geolocationActions[GeolocationActions.BLOCK_SALES_OUTSIDE_STORE] ??
      false
    );
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  canMakeSales: (state: IMerchantState, getters: any): boolean => {
    if (
      getters.usesGeolocation &&
      (getters.hasMerchantFlag(MerchantFlags.USE_GEO_BLOCK) ||
        getters.hasMerchantFlag(
          MerchantFlags.USE_GEO_BLOCK_SALES_OUTSIDE_STORE
        )) &&
      (!state.geolocationAllowed || !state.geolocationCheckDone)
    )
      return false;

    if (!state.merchant?.isPayJoyOpen) return false;
    if (state.merchant?.reachedSalesLimits) return false;
    if (getters.shouldBlockSalesOutsideStore) return false;

    return true;
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  canAcceptPayments: (state: IMerchantState, getters: any): boolean => {
    if (
      getters.usesGeolocation &&
      (getters.hasMerchantFlag(MerchantFlags.USE_GEO_BLOCK) ||
        getters.hasMerchantFlag(
          MerchantFlags.USE_GEO_BLOCK_SALES_OUTSIDE_STORE
        )) &&
      (!state.geolocationAllowed || !state.geolocationCheckDone)
    )
      return false;

    if (!state.merchant?.isPayJoyOpen) return false;
    if (getters.shouldBlockSalesOutsideStore) return false;

    return true;
  },
};

export default getters;
